import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import "bootstrap/dist/css/bootstrap.min.css";
import 'katex/dist/katex.min.css'
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './i18n';
import reportWebVitals from './reportWebVitals';
import AppSwitcher from "./AppSwitcher";


const container = document.getElementById('root');
const root = createRoot(container);
root.render(<AppSwitcher/>);

// ReactDOM.render(
//     <React.StrictMode>
//         <YuJaGlobalStateProvider>
//             <YuJaEventBusProvider>
//                 <AppSwitcher/>
//             </YuJaEventBusProvider>
//         </YuJaGlobalStateProvider>
//     </React.StrictMode>,
//     document.getElementById('root')
// );


// serviceWorkerRegistration.register();

// if ('serviceWorker' in navigator) {
//   alert('inside index js');
//   window.addEventListener('load', function() {
//     this.alert("registering service worker");
//     navigator.serviceWorker.register('/sw.js');
//     this.alert("registered service worker");
//   });
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
